import Raven from 'raven-js';
import getUserInfo from 'hub-http/userInfo';
import { useEffect, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { H6 } from 'foundations-components/transitional/components/H6';
import { H1 } from 'foundations-components/transitional/components/H1';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { SelectableButton } from 'foundations-components/transitional/components/SelectableButton';
import { getIsFreePortal } from 'onboarding-scopes';
import { TALK_TO_SALES_SUB_MODALS } from '../../../constants/talkToSales';
import { loadAndOpenSalesChat } from '../../../utils/loadAndOpenSalesChat';
import { getRepName } from '../../../utils/ums';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { GetACallModal } from './GetACallModal';
import { MeetingModal } from './MeetingModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AssignableModal = ({
  apiName,
  repInfo,
  trackingData,
  onClose
}) => {
  const [currentSubModal, setCurrentSubModal] = useState();
  const [loading, setLoading] = useState(true);
  const [isFreePortal, setIsFreePortal] = useState();
  const hideSubModal = () => setCurrentSubModal(undefined);
  const showGetACallModal = () => setCurrentSubModal(TALK_TO_SALES_SUB_MODALS.GET_A_CALL);
  const showMeetingModal = () => setCurrentSubModal(TALK_TO_SALES_SUB_MODALS.MEETING);
  const showChat = () => {
    loadAndOpenSalesChat({
      apiName,
      trackingData,
      isRetail: false
    });
    track('communicationMethodsInteraction', Object.assign({
      action: 'clicked chat with us'
    }, getTrackingProperties({
      apiName,
      trackingData
    }), {
      repName: getRepName(repInfo)
    }));
    onClose();
  };
  useEffect(() => {
    void getUserInfo().then(userInfo => {
      setIsFreePortal(getIsFreePortal(userInfo.user.scopes));
    }).catch(e => {
      setIsFreePortal(true);
      Raven.captureException(new Error('Communication methods modal opened without setting data', {
        cause: e
      }));
    }).finally(() => {
      setLoading(false);
    });
  }, []);
  useEffect(() => {
    track('communicationMethodsInteraction', Object.assign({
      action: 'viewed'
    }, getTrackingProperties({
      apiName,
      trackingData
    }), {
      repName: getRepName(repInfo)
    }));
    //submitPql({ ...upgradeData, isRetail: false, isAssignable: true, repInfo });
    //trackTalkToSalesPql(upgradeData.app);
  }, [repInfo, apiName, trackingData]);
  if (loading) {
    return null;
  }
  if (currentSubModal) {
    switch (currentSubModal) {
      case TALK_TO_SALES_SUB_MODALS.GET_A_CALL:
        return /*#__PURE__*/_jsx(GetACallModal, {
          apiName: apiName,
          trackingData: trackingData,
          onBackClick: hideSubModal,
          onClose: onClose
        });
      case TALK_TO_SALES_SUB_MODALS.MEETING:
        return /*#__PURE__*/_jsx(MeetingModal, {
          apiName: apiName,
          repInfo: repInfo,
          trackingData: trackingData,
          onClose: onClose
        });
      default: //no-op
    }
  }
  const tileWidth = isFreePortal ? 180 : 200;
  return /*#__PURE__*/_jsxs(Modal, {
    use: "conversational",
    width: 850,
    "data-test-id": "assignable-modal",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(H1, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.title"
        })
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      })]
    }), /*#__PURE__*/_jsx(DialogBody, {
      children: /*#__PURE__*/_jsx("div", {
        "data-test-id": "assignable-modal-body",
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsxs(Flex, {
            alignItems: "stretch",
            paddingInline: "200",
            justifyContent: "center",
            gap: "300",
            children: [/*#__PURE__*/_jsxs(SelectableButton, {
              "data-test-id": "communication-method-meeting",
              size: "large",
              width: tileWidth,
              onClick: showMeetingModal,
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "purchaseMotions.talkToSales.communicationMethods.meeting"
              }),
              children: [/*#__PURE__*/_jsx(Badge, {
                marginBlockEnd: "200",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "purchaseMotions.talkToSales.communicationMethods.recommended"
                })
              }), /*#__PURE__*/_jsx(Illustration, {
                name: "meetings-small",
                height: 75
              })]
            }), /*#__PURE__*/_jsx(SelectableButton, {
              "data-test-id": "communication-method-call",
              size: "large",
              width: tileWidth,
              onClick: showGetACallModal,
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "purchaseMotions.talkToSales.communicationMethods.call"
              }),
              children: /*#__PURE__*/_jsx(Illustration, {
                name: "calling-small",
                height: 75,
                marginBlockStart: "700"
              })
            }), /*#__PURE__*/_jsx(SelectableButton, {
              "data-test-id": "communication-method-email",
              size: "large",
              width: tileWidth,
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "purchaseMotions.talkToSales.communicationMethods.email"
              }),
              children: /*#__PURE__*/_jsx(Illustration, {
                name: "successfully-connected-email",
                height: 75,
                marginBlockStart: "700"
              })
            }), isFreePortal && /*#__PURE__*/_jsx(SelectableButton, {
              "data-test-id": "communication-method-chat",
              size: "large",
              width: tileWidth,
              title: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "purchaseMotions.talkToSales.communicationMethods.chatWithUs"
              }),
              onClick: showChat,
              children: /*#__PURE__*/_jsx(Illustration, {
                name: "contacts-chat",
                height: 75,
                marginBlockStart: "700"
              })
            })]
          }), /*#__PURE__*/_jsx(View, {
            marginBlockStart: "900",
            children: /*#__PURE__*/_jsxs(Text, {
              textAlign: "start",
              children: [/*#__PURE__*/_jsx(H6, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "purchaseMotions.talkToSales.communicationMethods.footer.header"
                })
              }), /*#__PURE__*/_jsx("p", {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "purchaseMotions.talkToSales.communicationMethods.footer.body"
                })
              })]
            })
          })]
        })
      })
    })]
  });
};